import React from 'react';
import { CenteredLoadingSpinner } from './CenteredLoadingSpinner';

/**
 * Spinner to use when loading a component.
 */
export const ComponentLoadingSpinner: React.FC<unknown> = () => {
  return <CenteredLoadingSpinner />;
};
